export const EMPTY_DUTY = {
  title: "",
  address: "",
  notes: "",
  date: new Date().toISOString().slice(0, 10),
  end_date: "",
  start_time: "",
  end_time: "",
  radius_m: 150,
  latitude: 25.2048,
  longitude: 55.2708,
  employee_ids: [],
};
